/**
 * Sets multiple cookies with the specified key-value pairs.
 * @function setCookieValues
 * @param {Array<{ key: string, value: string }>} values - An array of objects containing key-value pairs for cookies.
 * Each object must have a `key` representing the cookie name and a `value` representing the cookie value.
 * @param {boolean} secure - Determines if the Secure flag should be added to the cookies.
 * @param {number} [expiresInDays] - Optional. The number of days until the cookies expire.
 */
const setCookieValues = (
  values: { key: string; value: string }[],
  secure: boolean = false,
  expiresInDays = 1,
) => {
  values.forEach(({ key, value }) => {
    const secureFlag = secure ? '; Secure' : '';
    let expires = '';

    const date = new Date();
    date.setDate(date.getDate() + expiresInDays);
    expires = `; Expires=${date.toUTCString()}`;

    document.cookie = `${key}=${value}; domain=.ingresse.com; path=/${expires}${secureFlag}`;
  });
};

export default setCookieValues;
